import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { buildThumbnailUrl } from '@bd/bdcore-utilities';
import { css } from '@bd/bdui-styles/emotion';
import withData from '@bd/bdcore-data';
import { colors } from '../styles';
import ContactModal from './ContactModal';

const styles = css`
  width: 100%;
  height: auto;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  @media(min-width: 1200px) {
    height: 500px;
  }
  .CTAOverlay {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(46, 110, 156, 0.86);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 0;
  }
  .CTAOverlayWrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    height: 100%;
    justify-content: flex-end;
    padding-bottom: 0;
    @media(min-width: 768px) {
      padding: 10vw 0;
    }
    @media(min-width: 992px) {
      padding: 80px 0 85px;
    }
    h3 {
      font-weight: bold;
      font-size: 20px;
      color: ${colors.white};
      letter-spacing: 4.22px;
      text-align: center;
      line-height: 30px;
      text-transform: uppercase;
      padding: 0 10vw;
      @media(min-width: 768px) {
        font-size: 26px;
        letter-spacing: 5.48px;
      }
    }

    p {
      padding: 0 10vw;
      font-size: 18px;
      color: ${colors.white};
      letter-spacing: 0.3px;
      text-align: center;
      line-height: 34px;
      margin-bottom: 40px;
      @media(min-width: 768px) {
        font-size: 20px;
        letter-spacing: 0.33px;
        line-height: 37px;
      }
    }

    .BtnsWrapper {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      @media(min-width: 1200px) {
        flex-direction: row;
        justify-content: center;
        flex-wrap: wrap;
      }

      .BtnWrapper {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100px;
        background-color: ${colors.brand1};
        transition: all .3s ease-out;
        &:hover {
          background-color: ${colors.brand1};
          transition: all .3s ease-out;
        }
        @media(min-width: 768px) {
          max-width: 525px;
          height: 125px;
          margin-bottom: 30px;
          flex-direction: row;
          position: relative;
          &:last-child {
            margin-bottom: 0;
          }
        }
        @media(min-width: 1200px) {
          margin-bottom: 30px;
          margin-right: 30px;
          &:last-child {
            margin-right: 0;
            margin-bottom: 30px;
          }
        }
        .ImageSection {
          display: none;
          @media(min-width: 768px) {
            display: block;
            width: 175px;
            height: 100%;
          }
        }
      }
      .BtnRigthWrapper {
        width: 100vw;
        background-color: ${colors.brand2};
        cursor: pointer;
        transition: all .5s ease-out;
        @media(min-width: 768px) {
          width: 525px;
          height: 125px;
        }
        &:hover {
          background-color: ${colors.brand2};
          transition: all .5s ease-out;
        }
      }
      .ContentSection {
        display: flex;
        height: 100%;
        align-items: center;
        @media(min-width: 768px) {
          padding-left: 65px;
        }
        img {
          flex: 1;
          @media(min-width: 768px) {
            position: absolute;
            left: 140px;
          }
        }
        .ContentWrapper {
          flex: 2.5;

          h3 {
            letter-spacing: 1.74px;
            text-transform: uppercase;
            padding: 0;
            text-align: left;
            margin-bottom: -5px;
          }
          span {
            font-size: 20px;
            color: ${colors.white};
            letter-spacing: 1.74px;
            text-transform: uppercase;
          }
        }
      }
    }
  }
`;

function CallToAction({ page, builder }) {
  return (
    <div className={styles} style={{ backgroundImage: `url(${buildThumbnailUrl(page.page_image.contentUrl, { width: 800, height: 800 })})` }}>
      <div className="CTAOverlay" />
      <div className="container CTAOverlayWrapper">
        <h3>{get(page, 'lead_copy')}</h3>
        <p>{get(page, 'body_copy')}</p>
        <div className="BtnsWrapper">
          <a className="BtnWrapper" href={`tel:${get(builder, 'telephone').replace(/[^0-9]/g, '')}`}>
            <div className="ImageSection" style={{ backgroundImage: `url(${buildThumbnailUrl(page.image_left_section.contentUrl, { width: 175, height: 125 })})` }} />
            <div className="ContentSection">
              <img src="/images/icon-cta-left.svg" alt="Call Icon" />
              <div className="ContentWrapper">
                <h3>Call Or Text</h3>
                <span>816 987 7878</span>
              </div>
            </div>
          </a>
          <ContactModal>
            <div className="BtnWrapper BtnRigthWrapper">
              <div className="ImageSection" style={{ backgroundImage: `url(${buildThumbnailUrl(page.image_right_section.contentUrl, { width: 175, height: 125 })})` }} />
              <div className="ContentSection">
                <img src="/images/icon-cta-right.svg" alt="Call Icon" />
                <div className="ContentWrapper">
                  <h3>Schedule a tour</h3>
                  <span>Book Now!</span>
                </div>
              </div>
            </div>
          </ContactModal>
        </div>
      </div>
    </div>
  );
}

CallToAction.propTypes = {
  page: PropTypes.object.isRequired,
  builder: PropTypes.object.isRequired,
};

export default withData(
  {
    page: 'call_to_action',
    builder: true,
  },
)(CallToAction);



// WEBPACK FOOTER //
// ./src/components/CallToAction.js